module.exports = __webpack_public_path__ + "static/logo-white-8a71035d9c82e7b27e822dac48811c59.png";